import { render } from "./carInfo.vue?vue&type=template&id=75a7898a&scoped=true&ts=true"
import script from "./carInfo.vue?vue&type=script&lang=ts"
export * from "./carInfo.vue?vue&type=script&lang=ts"

import "./carInfo.vue?vue&type=style&index=0&id=75a7898a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a7898a"]])

export default __exports__